// extracted by mini-css-extract-plugin
module.exports = {"error":"CollectionsModal-module_error_2iyOA"};